import { getEmbarcacaoMotores } from "./embarcacoes.gateway";
import { isEmbarcacaoMotoresEmpty } from "./embarcacoes.types";
import type { EmbarcacaoMotor, EmbarcacaoMotoresState } from "./embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

export const MOTORES_SESSION_EXPIRED_MESSAGE =
  "Sua sessão expirou. Entre novamente para consultar os detalhes da embarcação.";
export const MOTORES_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar os detalhes desta embarcação.";
export const MOTORES_NOT_FOUND_MESSAGE = "Embarcação não encontrada.";
export const MOTORES_ERROR_MESSAGE = "Não foi possível carregar os Motores da embarcação.";

const MOTORES_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoMotor[]> = {
  load: getEmbarcacaoMotores,
  isEmpty: isEmbarcacaoMotoresEmpty,
  messages: {
    sessionExpired: MOTORES_SESSION_EXPIRED_MESSAGE,
    forbidden: MOTORES_FORBIDDEN_MESSAGE,
    notFound: MOTORES_NOT_FOUND_MESSAGE,
    error: MOTORES_ERROR_MESSAGE,
  },
};

interface UseEmbarcacaoMotoresResult extends EmbarcacaoMotoresState {
  reload: () => void;
}

/**
 * Consulta os Motores da embarcação pedida (AC4). Somente leitura: nenhuma
 * escrita é disparada na abertura nem no fechamento do modal.
 */
export function useEmbarcacaoMotores(id: string): UseEmbarcacaoMotoresResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, MOTORES_QUERY);

  return { ...state, motores: data };
}
